import { reduxKey } from './constants';
import { handleActions } from 'redux-actions';
import { initializeHead } from './actions';
import { HeadSlice } from './types';

const handler = handleActions<HeadSlice, any>(
  {
    [initializeHead.toString()]: (
      state,
      action: ReturnType<typeof initializeHead>
    ) => ({
      ...state,
      headState: action.payload.head,
    }),
  },
  {
    headState: {
      title: '',
      link: [],
      meta: [],
      script: [],
      style: [],
    },
  }
);

const reducers = {
  [`${reduxKey}`]: handler,
};

export default reducers;
